export default __webpack_public_path__ + "static/media/audio.51701625.svg";